import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Checkbox } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import UpdateConditionsAndPricesWarning from '../../../../../components/UpdateConditionsAndPricesWarning';
import { ApproveOrdersAlertContentProps } from '../../types/OrderListMassActionsAlertContent.types';

const ApproveOrdersMassActionAlertContent = ({
  updateConditionsOnStatusChange,
  onChangeUpdateConditionsOnStatusChange,
}: ApproveOrdersAlertContentProps) => {
  const { translate } = useTranslation();

  const handleChangeUpdateConditionsOnStatusChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    onChangeUpdateConditionsOnStatusChange(event.target.checked);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '24px',
        maxWidth: 400,
      }}
    >
      <Typography variant="subtitle1" color="textSecondary">
        {translate(LangEnum.GLOBAL_ORDER_DATA_CAN_BE_CHANGED_BUT_NOT_UPDATED)}
      </Typography>
      <Typography variant="overline" color="textSecondary">
        {translate(LangEnum.GLOBAL_UPDATE_CONFIRM_QUESTION)}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          columnGap: '6px',
        }}
      >
        <Checkbox
          color="primary"
          checked={updateConditionsOnStatusChange}
          onChange={handleChangeUpdateConditionsOnStatusChange}
          size="medium"
          style={{ padding: 0, width: 18, height: 18 }}
        />

        <Typography variant="subtitle1">
          {translate(LangEnum.ORDER_MASS_ACTIONS_UPDATE_PRICES_AND_CONDITIONS)}
        </Typography>
      </Box>
      <UpdateConditionsAndPricesWarning />
    </Box>
  );
};

export default ApproveOrdersMassActionAlertContent;
